module.exports = __webpack_public_path__ + "img/battle-crackers-win.c2210a3f.jpg";